import { semantic } from '../ui/theme/semanticTokens';

const ui = {
  colors: {
    bg: semantic.legacy.bg,
    surface: semantic.legacy.surface,
    surfaceAlt: semantic.legacy.surfaceAlt,
    surfaceMuted: semantic.legacy.surfaceMuted,
    primary: semantic.legacy.primary,
    primaryDark: semantic.legacy.primaryDark,
    primaryLight: semantic.legacy.primaryLight,
    primarySoft: semantic.legacy.primarySoft,
    secondary: semantic.legacy.secondary,
    secondaryLight: semantic.legacy.secondaryLight,
    secondarySoft: semantic.legacy.secondarySoft,
    accent: semantic.legacy.accent,
    accentSoft: semantic.legacy.accentSoft,
    border: semantic.legacy.border,
    borderLight: semantic.legacy.borderLight,
    text: semantic.legacy.text,
    textMuted: semantic.legacy.textMuted,
    textLight: semantic.legacy.textLight,
    success: semantic.legacy.success,
    successLight: semantic.legacy.successLight,
    successSoft: semantic.legacy.successSoft,
    warning: semantic.legacy.warning,
    warningLight: semantic.legacy.warningLight,
    warningSoft: semantic.legacy.warningSoft,
    danger: semantic.legacy.danger,
    dangerLight: semantic.legacy.dangerLight,
    dangerSoft: semantic.legacy.dangerSoft,
    purple: semantic.legacy.purple,
    purpleSoft: semantic.legacy.purpleSoft,
    gradient: `linear-gradient(135deg, ${semantic.legacy.primaryDark} 0%, ${semantic.legacy.primary} 100%)`,
    gradientPrimary: `linear-gradient(135deg, ${semantic.legacy.primaryDark} 0%, ${semantic.legacy.primary} 100%)`,
  },
  radius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    pill: '999px',
  },
  shadow: {
    soft: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
    medium: '0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)',
    strong: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)',
    focus: '0 0 0 3px rgba(28, 90, 165, 0.14)',
    glow: '0 0 20px rgba(28, 90, 165, 0.16)',
  },
  transition: {
    fast: 'all 0.15s ease',
    normal: 'all 0.2s ease',
    slow: 'all 0.3s ease',
  },
  page: {
    maxWidth: '1400px',
    contentMaxWidth: '900px',
  },
  typography: {
    fontFamily: "'Hanken Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
  },
};

export { ui };
